<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
      relative
    "
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 absolute">
      <b-card no-body class="bg-secondary border-0 mb-0 p-0">
        <b-card-body class="flex p-0 fullpage-bgcolor">
          <div class="w-1/2 flex items-center justify-center">
            <img src="@/assets/images/login.png" alt="login" class="mx-auto" />
          </div>
          <div class="w-1/2 bg-white">
            <div class="p-4 login-tabs-container">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <div class="mb-4">
                  <h4 class="mb-2 text-xl font-medium">Create Account</h4>
                  <p class="text-lg">
                    Fill the below form to create a new account.
                  </p>
                </div>
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div class="flex justify-between items-center my-2">
                    <base-input
                      alternative
                      class="pr-2"
                      prepend-icon="ni ni-badge"
                      placeholder="First name"
                      name="First Name"
                      :rules="{ required: true, alpha_dash: true }"
                      v-model="firstname"
                    >
                    </base-input>

                    <base-input
                      alternative
                      class=""
                      prepend-icon="ni ni-badge"
                      placeholder="Last name"
                      name="Last Name"
                      :rules="{ required: true, alpha_dash: true }"
                      v-model="lastname"
                    >
                    </base-input>
                  </div>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Mobile"
                    :rules="{ required: true }"
                    prepend-icon="ni ni-email-83"
                    placeholder="Mobile"
                    v-model="mobile"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="password"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Confirm Password"
                    :rules="{ required: true, confirmed: 'Password' }"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Confirm Password"
                    v-model="confirmpassword"
                  >
                  </base-input>

                  <!-- <div class="my-2">
                    <b-form-radio
                      v-model="gender"
                      name="Gender"
                      value="male"
                      class="ml-2 custom-control-inline"
                      >Male</b-form-radio
                    >
                    <b-form-radio
                      v-model="gender"
                      name="Gender"
                      value="female"
                      class="ml-4 custom-control-inline"
                      >Female</b-form-radio
                    >
                  </div> -->

                  <OTP @set-otp="setOTP" :mobile="mobile" type="Register" />
                  <div class="my-2">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="agree"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                    >
                      I accept the terms & conditions.
                    </b-form-checkbox>
                  </div>

                  <div class="flex justify-between mt-4">
                    <b-button
                      variant="outline-primary"
                      outline
                      class="w-2/5 mb-2"
                      @click="handleLoginClick"
                      >Go to Login</b-button
                    >
                    <b-button variant="primary" class="w-2/5 mb-2" type="submit"
                      >Register</b-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import OTP from "./components/OTP.vue";

export default {
  components: {
    OTP,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      mobile: "",
      email: "",
      password: "",
      confirmpassword: "",
      gender: "",
      agree: false,
      otp: "",
    };
  },
  methods: {
    onSubmit() {
      const payload = {
        firstname: this.firstname,
        lastname: this.lastname,
        password: this.password,
        mobile: this.mobile,
        otp: this.otp,
      };
      let loader = this.$loading();
      try {
        this.$store.dispatch("auth/signupWithPassword", payload);
        this.$router.push({ name: "social-admin-home" });
        loader.close();
      } catch (error) {
        loader.close();
      }
      // this will be called only after form is valid. You can do an api call here to register users
    },
    setOTP(otp) {
      this.otp = otp;
    },
    handleLoginClick() {
      this.$router.push({ name: "login-with-password" });
    },
  },
};
</script>

<style>
.login-tabs-container {
  min-height: 505px;
}
.cust-divider3 {
  border-bottom: 3px solid #e9ecef;
}
.fullpage-bgcolor {
  background-color: #eff2f7;
}
.bor {
  border: 1px solid rgba(155, 154, 154, 0.623);
}
.cust-padbtn {
  padding: 0px 5px !important;
}
</style>
